import {FC} from 'react'
import {Link} from 'react-router-dom'

const Error404: FC = () => (
  <>
    <p className='asa-error-page__code' aria-hidden='true'>
      <span className='asa-text-gradient'>۴۰۴</span>
    </p>
    <h1 className='asa-page-heading'>صفحه پیدا نشد</h1>
    <p className='asa-error-page__text'>
      نشانی این صفحه درست نیست یا صفحه جابه‌جا شده است. تا چند لحظه دیگر به داشبورد می‌روید.
    </p>
    <Link to='/dashboard' className='btn btn-primary'>
      بازگشت به داشبورد
    </Link>
  </>
)

export {Error404}
